"use client";

import React from "react";
import { Phone, Loader, CircleCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
function EvaluationForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center p-8 text-center bg-green-50/50 border border-green-200 rounded-lg h-full min-h-[300px]">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
          <CircleCheck className="w-8 h-8 text-green-600" />
        </div>
        <h3 className="text-xl font-semibold text-green-900 mb-2">
          Request Received
        </h3>
        <p className="text-green-800 max-w-xs mx-auto">{successMessage}</p>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-5">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {}
        <FormField control={control} name="company_name" rules={{
        required: "Company Name is required"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground font-medium">
                Company Name <span className="text-destructive">*</span>
              </FormLabel>
              <FormControl>
                <input className="flex h-10 w-full rounded-sm border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50" placeholder="Acme Industries" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        {}
        <FormField control={control} name="contact_name" rules={{
        required: "Contact Person is required"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground font-medium">
                Contact Person <span className="text-destructive">*</span>
              </FormLabel>
              <FormControl>
                <input className="flex h-10 w-full rounded-sm border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50" placeholder="Jane Doe" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {}
        <FormField control={control} name="email" rules={{
        required: "Email is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Invalid email address"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground font-medium">
                Email Address <span className="text-destructive">*</span>
              </FormLabel>
              <FormControl>
                <input type="email" className="flex h-10 w-full rounded-sm border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50" placeholder="jane.doe@acme.com" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        {}
        <FormField control={control} name="phone" rules={{
        required: "Phone number is required",
        pattern: {
          value: /^[\d\+\-\(\)\s\.]+$/,
          message: "Invalid phone number"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground font-medium">
                Phone Number <span className="text-destructive">*</span>
              </FormLabel>
              <FormControl>
                <input type="tel" className="flex h-10 w-full rounded-sm border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50" placeholder="(555) 123-4567" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {}
        <FormField control={control} name="facility_location" render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground font-medium">
                Facility Location
              </FormLabel>
              <FormControl>
                <input className="flex h-10 w-full rounded-sm border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50" placeholder="Houston, TX, USA" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        {}
        <FormField control={control} name="catalyst_quantity" rules={{
        min: {
          value: 0,
          message: "Quantity must be positive"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground font-medium">
                Approx. Spent CO Catalyst (tons)
              </FormLabel>
              <FormControl>
                <input type="number" className="flex h-10 w-full rounded-sm border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50" placeholder="10" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      {}
      <FormField control={control} name="additional_details" render={({
      field
    }) => <FormItem>
            <FormLabel className="text-foreground font-medium">
              Additional Details / Questions
            </FormLabel>
            <FormControl>
              <textarea className="flex min-h-[100px] w-full rounded-sm border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 resize-y" placeholder="Any specific concerns, timeline, or other information..." {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-3 bg-red-50 border border-red-200 rounded-md text-red-600 text-sm">
          {submitError}
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full h-12 text-base font-semibold bg-[var(--chart-2)] text-[var(--primary)] hover:bg-[var(--chart-2)]/90 border-none shadow-md cursor-pointer">
        {isSubmitting ? <>
            <Loader className="mr-2 h-5 w-5 animate-spin" />
            Submitting Request...
          </> : "Request Evaluation"}
      </Button>
    </Form>;
}
export default function RequestACoCatalystEvaluation() {
  return <section id="request-a-co-catalyst-evaluation" className="py-20 bg-background relative overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {}
          <div className="space-y-8">
            <div className="space-y-4">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-foreground leading-tight">
                Ready to turn disposal costs into revenue?
              </h2>
              <p className="text-lg max-w-xl !text-[hsl(210,17%,98%)]">
                Catalyst Resource Group, LLC works with industrial facilities to
                safely, efficiently, and profitably recover valuable metals from
                spent CO catalyst. Start your evaluation today.
              </p>
            </div>

            <div className="pt-4 border-t border-border">
              <p className="text-sm font-medium text-muted-foreground uppercase tracking-wider mb-4">
                Direct Contact
              </p>
              <div className="flex flex-col space-y-2">
                <h3 className="text-2xl font-bold">
                  Curt Harke
                </h3>
                <Link to="tel:9512199312" className="group flex items-center gap-3 text-3xl font-bold w-fit !text-[hsl(78,98%,50%)] md:text-4xl hover:text-[var(--chart-2)]">
                  <Phone className="h-8 w-8 md:h-10 md:w-10 fill-current" />
                  <span>(951) 219-9312</span>
                </Link>
                <p className="text-muted-foreground mt-2">
                  For faster service, call directly or fill out the form.
                </p>
              </div>
            </div>
          </div>

          {}
          <div className="bg-muted/30 p-6 md:p-8 lg:p-10 rounded-xl border border-border shadow-sm">
            <div className="mb-6">
              <h3 className="text-2xl font-bold text-foreground">
                CO Catalyst Evaluation Request
              </h3>
              <p className="text-muted-foreground mt-1">
                Provide your details below and we will contact you shortly.
              </p>
            </div>

            <FormProvider formId="catalyst_evaluation_form_home" sectionName="request-evaluation-section" defaultValues={{
            company_name: "",
            contact_name: "",
            email: "",
            phone: "",
            facility_location: "",
            catalyst_quantity: "",
            additional_details: ""
          }} validationRules={{
            company_name: {
              required: true
            },
            contact_name: {
              required: true
            },
            email: {
              required: true,
              pattern: "email"
            },
            phone: {
              required: true,
              pattern: "phone"
            },
            catalyst_quantity: {
              min: 0
            }
          }} submitText="Request Evaluation" successMessage="Thank you! Your evaluation request has been submitted successfully. We will be in touch soon." errorMessage="Failed to submit request. Please try again." className="w-full">
              <EvaluationForm />
            </FormProvider>
          </div>
        </div>
      </div>
    </section>;
}